import { render, staticRenderFns } from "./Patrol4mList.vue?vue&type=template&id=931b96ec&scoped=true&"
import script from "./Patrol4mList.vue?vue&type=script&lang=js&"
export * from "./Patrol4mList.vue?vue&type=script&lang=js&"
import style0 from "./Patrol4mList.vue?vue&type=style&index=0&id=931b96ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931b96ec",
  null
  
)

export default component.exports